export default __webpack_public_path__ + "static/media/ui_back.329e0c1a.svg";